import React from 'react'
import { observer } from 'mobx-react-lite'

import { PropFilters } from './PropFilters'
import { PropFilterItem } from './PropFilter'

import { useStore } from '../hooks/storeHook'
import { useLazyUnEffect } from '../hooks/commonHooks'
import { useHomeHasStoreType } from '../hooks/myProductHooks'

import { EnumKey, exact } from '../common/tsUtils'
import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'
import { MyProductsTableFilterColumn } from '../server/mpsklad_core/Models/MyProductsTableFilterColumn'

export const MyProductsPropFilter =
  observer(() => {
    const {
      productStore: {
        myProducts: {
          setPropFilter, resetPropFilters, findPropFilterValue, getPropFilterReadOnly
        }
      }
    } = useStore()

    const homeHasStoreType = useHomeHasStoreType()

    useLazyUnEffect(resetPropFilters)

    const createFilterProps =
      (filter: EnumKey<typeof MyProductsTableFilterColumn>) => ({
        value: findPropFilterValue(filter),
        setValue: (value: string | undefined) => setPropFilter(filter, value),
        readOnly: getPropFilterReadOnly(filter)
      })

    const filters =
      exact<Array<PropFilterItem | null>>([{
        placeholder: 'Название',
        ...createFilterProps('name')
      }, {
        placeholder: 'Артикул',
        ...createFilterProps('article')
      }, {
        placeholder: 'Штрихкод',
        ...createFilterProps('barcodes')
      }])

    // TODO: (redesign) Replace with strict switch-case
    if (homeHasStoreType(IntegrationType.Ozon)) {
      filters.push({
        placeholder: 'Артикул Ozon',
        ...createFilterProps('ozonArticle')
      }, {
        placeholder: 'Синхронизация с Ozon',
        isBoolean: true,
        allowMixed: true,
        ...createFilterProps('syncOzon')
      })
    }

    if (homeHasStoreType(IntegrationType.Wildberries)) {
      filters.push({
        placeholder: 'Код размера Wildberries',
        ...createFilterProps('wbChrtId')
      }, {
        placeholder: 'Синхронизация с Wildberries',
        isBoolean: true,
        allowMixed: true,
        ...createFilterProps('syncWb')
      })
    }

    if (homeHasStoreType(IntegrationType.YandexMarket)) {
      filters.push({
        placeholder: 'SKU в Yandex.Market',
        ...createFilterProps('yandexMarketShopSku')
      }, {
        placeholder: 'Синхронизация с Yandex.Market',
        isBoolean: true,
        allowMixed: true,
        ...createFilterProps('syncYandexMarket')
      })
    }

    return <PropFilters filters={filters}/>
  })